import { Component, Input, OnInit } from '@angular/core';
// import { computerScienceCourses } from './courses';
// import { Course } from '../../interfaces/course';
import { DataService } from '../../services/data.service';
import { environment } from 'src/environments/environment';
import { Filter } from '../../interfaces/filter';
import { Subject, debounceTime } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-courses-list',
  templateUrl: './courses-list.component.html',
  styleUrls: ['./courses-list.component.scss']
})
export class CoursesListComponent implements OnInit {
  @Input({ required: true }) pageData!: any;
  isLoading: boolean = false;
  coursesTableData: any = null;
  isPageLoaded: boolean = false;
  selectedPeriodFilter: string = '-1';
  selectedTypeFilter: string = '-1';
  searchTerm: string = '';
  searchTermObj = new Subject<string>();
  sectionSize: number = 0;
  urlParamsBaseName = "student_all_courses_";
  isServerError: boolean = false;

  constructor(private dataService: DataService, private router: Router, private route: ActivatedRoute) { 
    this.searchTermObj
      .pipe(
        debounceTime(1000)
      )
      .subscribe(term => {
        this.searchTerm = term;
        this.getSearchCourseData();
      });
  }

  ngOnInit(): void {
    this.sectionSize = this.pageData.sectionSize;
    this.getUrlParameters();
  }

  private getIndexData() {
    this.isLoading = true;
    var url = environment.apiUrl + '/Portal/StudentAllCoursesBlockList/Index';
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      semesterFilterValue: this.selectedPeriodFilter,
      departmentFilterValue: this.selectedTypeFilter,
      searchValue: this.searchTerm,
      sectionSize: this.sectionSize
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {    
        responseData.semesterFilter.push({ value: '-1', label: this.pageData.defaultPeriodFilterText, checked: false });
        let index = responseData.semesterFilter.findIndex((c: any) => c.value == this.selectedPeriodFilter);
        if(index == -1) { 
          index = responseData.semesterFilter.findIndex((c: any) => c.value == '-1');
          responseData.semesterFilter[index].checked = true;
          this.selectedPeriodFilter = '-1';
        } else {
          responseData.semesterFilter[index].checked = true;
        }

        responseData.departmentFilter.push({ value: '-1', label: this.pageData.defaultDepartmentFilterText, checked: false });
        index = responseData.departmentFilter.findIndex((c: any) => c.value == this.selectedTypeFilter);
        if(index == -1) { 
          index = responseData.departmentFilter.findIndex((c: any) => c.value == '-1');
          responseData.departmentFilter[index].checked = true;
          this.selectedTypeFilter = '-1';
        } else {
          responseData.departmentFilter[index].checked = true;
        }

        this.coursesTableData = responseData;
        this.isLoading = false;
        this.isPageLoaded = true;
      },
      error: (e) => {
        console.error(e);
        this.isServerError = true;
      },
    });
  }

  private getSearchCourseData() {
    if(this.isLoading) return;
    this.updateUrlParameters();
    this.isLoading = true;
    var url = environment.apiUrl + '/Portal/StudentAllCoursesBlockList/SearchStudentCourses';
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      semesterFilterValue: this.selectedPeriodFilter,
      departmentFilterValue: this.selectedTypeFilter,
      searchValue: this.searchTerm,
      sectionSize: this.sectionSize
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.coursesTableData.coursesList = responseData.coursesList;
        this.isLoading = false;
      },
      error: (e) => {
        console.error(e);
        this.isLoading = false;
        this.isServerError = true;
      },
    });
  }

  periodFilterChangeEvent(filter: Filter[]) {
    let index = filter.findIndex(c => c.checked);
    if(index == -1) return;
    this.selectedPeriodFilter = filter[index].value;
    this.getSearchCourseData();
  }

  typeFilterChangeEvent(filter: Filter[]) {
    let index = filter.findIndex(c => c.checked);
    if(index == -1) return;
    this.selectedTypeFilter = filter[index].value;
    this.getSearchCourseData();
  }

  onKeySearch(event: any) {
    this.searchTermObj.next(event.target.value);
  }

  loadMoreBtnClick(departmentId: string) {
    if(this.isLoading) return;
    let index = this.coursesTableData.coursesList.findIndex((c: any) => c.departmentId == departmentId);
    if(index == -1) return;
    else 
      this.coursesTableData.coursesList[index].loading = true;

    var url = environment.apiUrl + '/Portal/StudentAllCoursesBlockList/LoadMoreCoursesForDepartment';
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      semesterFilterValue: this.selectedPeriodFilter,
      departmentFilterValue: this.selectedTypeFilter,
      searchValue: this.searchTerm,
      departmentId: departmentId,
      alreadyDisplayCount: this.coursesTableData.coursesList[index].courses.length,
      sectionSize: this.sectionSize
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.coursesTableData.coursesList[index] = responseData;
      },
      error: (e) => {
        console.error(e);
        this.coursesTableData.coursesList[index].loading = false;
        this.isServerError = true;
      },
    });
  }

  getMoreBtnText(length: number, count: number): string {
    return this.pageData.moreCoursesBtnText.replace('{1}', count).replace('{0}', length);
  }

  private getUrlParameters() {  
    this.route.queryParams.subscribe(params => {
      this.selectedPeriodFilter = params[this.urlParamsBaseName + "periodFilter"] || '-1';
      this.selectedTypeFilter = params[this.urlParamsBaseName + "typeFilter"] || '-1';
      this.searchTerm = params[this.urlParamsBaseName + "searchTerm"] || '';
      this.getIndexData();
    });
  }

  private updateUrlParameters() {
    var searchParams = new URL(window.location.href).searchParams;
    let queryParams: any = {};

    searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    if (this.selectedPeriodFilter && this.selectedPeriodFilter !== '-1')
      queryParams[this.urlParamsBaseName + "periodFilter"] = this.selectedPeriodFilter;
    else
      delete queryParams[this.urlParamsBaseName + "periodFilter"];

    if (this.selectedTypeFilter && this.selectedTypeFilter !== '-1')
      queryParams[this.urlParamsBaseName + "typeFilter"] = this.selectedTypeFilter;
    else
      delete queryParams[this.urlParamsBaseName + "typeFilter"];

    if (this.searchTerm && this.searchTerm !== '')
      queryParams[this.urlParamsBaseName + "searchTerm"] = this.searchTerm;
    else
      delete queryParams[this.urlParamsBaseName + "searchTerm"];

    queryParams = Object.keys(queryParams).length > 0 ? queryParams : null;

    var url = this.router.createUrlTree([], {
        relativeTo: this.route,
        queryParams: queryParams,
        //queryParamsHandling: 'merge'
      }).toString();

    window.history.pushState({ path: url }, '', url);
  }
}
